import { InvitationDomain } from 'models/Invitation';
import { Invitation } from 'models/Invitation/type';
import { useEffect, useState } from 'react';
import { setExceptionError } from 'stores/errorSlice';
import { useAppDispatch } from 'stores/type';

export const useInvitation = (
  invitationToken?: string
): [boolean, Invitation?] => {
  const [loading, setLoading] = useState(true);
  const [invitation, setInvitation] = useState<Invitation>();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const getDetail = async (token: string) => {
      InvitationDomain.detail(token)
        .then((result) => {
          if (result.isSuccess()) {
            setInvitation(result.value);
          }

          setLoading(false);
        })
        .catch((e) => {
          dispatch(setExceptionError(e));
        });
    };

    if (invitationToken) {
      getDetail(invitationToken);
    } else {
      setLoading(false);
    }
  }, [dispatch, invitationToken]);

  return [loading, invitation];
};
